import { ITableReactionEvent } from '../State/ITableReactionState';

type RoomTableReactionListener = (event: ITableReactionEvent) => void;

class RoomTableReactionEventBus {
    private listeners: Set<RoomTableReactionListener> = new Set();

    public publish = (event: ITableReactionEvent) => {
        Array.from(this.listeners).forEach((listener) => listener(event));
    };

    public subscribe = (listener: RoomTableReactionListener): (() => void) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };
}

export const roomTableReactionEventBus = new RoomTableReactionEventBus();
